<template>
    <span class="f-w-bold small-4">
        <span class="badge c-bright f-w-bold" v-bind:class="cssClasses">
            {{ status.label }}
        </span>
    </span>
</template>
<script>
import { ORDER_STATUS_ACTIVE, ORDER_STATUS_CANCELLED, ORDER_STATUS_OVERDUE, ORDER_STATUS_PENDING, ORDER_STATUS_TRIALING, ORDER_STATUS_REFUNDED, ORDER_STATUS_COMPLETED } from '../../constants';

export default {
    props: {
        status: {
            type: Object,
            required: true,
        },
    },
    computed: {
        cssClasses() {
            switch (this.status.key) {
                case ORDER_STATUS_PENDING:
                case ORDER_STATUS_OVERDUE:
                    return 'c-warning-bg c-error';
                case ORDER_STATUS_CANCELLED:
                case ORDER_STATUS_REFUNDED:
                    return 'c-error-bg';
                case ORDER_STATUS_TRIALING:
                case ORDER_STATUS_COMPLETED:
                case ORDER_STATUS_ACTIVE:
                default:
                    return 'c-theme-bg';
            }
        }
    }
}
</script>
